// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar_container__GqHI\\+ {
  padding: 20px;
  width: 80%;
  border-radius: 10px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 2px 2px 5px var(--blue-color);
  position: sticky;
  top: 10px;
  text-wrap: nowrap;
  z-index: 100;
}

.navbar_title__pqYyl {
  color: var(--blue-color);
  font-weight: 300;
  font-family: "Cairo";

  text-transform: capitalize;
}

.navbar_menu__6DnaF {
  display: flex;
  align-items: center;
  gap: 20px;
}

.navbar_search__bfsNW {
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: #2e374a;
  padding: 10px;
  border-radius: 10px;
}

.navbar_input__Apc0\\+ {
  background-color: transparent;
  border: none;
  color: var(--text);
}

.navbar_icons__walkC {
  display: flex;
  gap: 20px;
}

.navbar_active__8iqF2 {
  background-color: var(--primary-color);
  color: var(--light-color);
  box-shadow: 0px 0px 4px rgba(71, 91, 232, 0.04);
}

.navbar_link__mmiDW {
  background-color: var(--primary-color);
  color: var(--light-color);
  font-family: "Cairo";

  box-shadow: 0px 0px 4px rgba(71, 91, 232, 0.04);
  text-decoration: none;
  padding: 10px;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
}
.navbar_userInfo__28HsA {
  display: flex;
  align-items: center;
  font-family: "Cairo";
}

.navbar_username__7MiCF {
  margin-right: 10px;
  font-family: "Cairo";
  display: flex;
  align-items: center;
  gap: 4px;
  color: var(--blue-color);

  height: 40px;
}

.navbar_username__7MiCF svg {
  font-size: 1.2rem;
}

.navbar_logoutBtn__kaBkJ {
  color: var(--blue-color);
  border: none;
  padding: 8px 16px;
  border-radius: 15px;
  cursor: pointer;
  font-family: "Cairo";
  transition: 0.3s;
}

a:hover {
  background-color: var(--blue-color);
  color: white;
  font-family: "Cairo";
}

.navbar_logoutBtnn__goueh {
  background-color: var(--blue-color);
  margin: 0 15px;
  color: #fff;
  padding: 5px;
  border-radius: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/navbar/navbar.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yCAAyC;EACzC,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,oBAAoB;;EAEpB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;EACzB,oBAAoB;;EAEpB,+CAA+C;EAC/C,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;;EAExB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".container {\n  padding: 20px;\n  width: 80%;\n  border-radius: 10px;\n  background-color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  box-shadow: 2px 2px 5px var(--blue-color);\n  position: sticky;\n  top: 10px;\n  text-wrap: nowrap;\n  z-index: 100;\n}\n\n.title {\n  color: var(--blue-color);\n  font-weight: 300;\n  font-family: \"Cairo\";\n\n  text-transform: capitalize;\n}\n\n.menu {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.search {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background-color: #2e374a;\n  padding: 10px;\n  border-radius: 10px;\n}\n\n.input {\n  background-color: transparent;\n  border: none;\n  color: var(--text);\n}\n\n.icons {\n  display: flex;\n  gap: 20px;\n}\n\n.active {\n  background-color: var(--primary-color);\n  color: var(--light-color);\n  box-shadow: 0px 0px 4px rgba(71, 91, 232, 0.04);\n}\n\n.link {\n  background-color: var(--primary-color);\n  color: var(--light-color);\n  font-family: \"Cairo\";\n\n  box-shadow: 0px 0px 4px rgba(71, 91, 232, 0.04);\n  text-decoration: none;\n  padding: 10px;\n  border-radius: 10px;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  -ms-border-radius: 10px;\n  -o-border-radius: 10px;\n}\n.userInfo {\n  display: flex;\n  align-items: center;\n  font-family: \"Cairo\";\n}\n\n.username {\n  margin-right: 10px;\n  font-family: \"Cairo\";\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  color: var(--blue-color);\n\n  height: 40px;\n}\n\n.username svg {\n  font-size: 1.2rem;\n}\n\n.logoutBtn {\n  color: var(--blue-color);\n  border: none;\n  padding: 8px 16px;\n  border-radius: 15px;\n  cursor: pointer;\n  font-family: \"Cairo\";\n  transition: 0.3s;\n}\n\na:hover {\n  background-color: var(--blue-color);\n  color: white;\n  font-family: \"Cairo\";\n}\n\n.logoutBtnn {\n  background-color: var(--blue-color);\n  margin: 0 15px;\n  color: #fff;\n  padding: 5px;\n  border-radius: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `navbar_container__GqHI+`,
	"title": `navbar_title__pqYyl`,
	"menu": `navbar_menu__6DnaF`,
	"search": `navbar_search__bfsNW`,
	"input": `navbar_input__Apc0+`,
	"icons": `navbar_icons__walkC`,
	"active": `navbar_active__8iqF2`,
	"link": `navbar_link__mmiDW`,
	"userInfo": `navbar_userInfo__28HsA`,
	"username": `navbar_username__7MiCF`,
	"logoutBtn": `navbar_logoutBtn__kaBkJ`,
	"logoutBtnn": `navbar_logoutBtnn__goueh`
};
export default ___CSS_LOADER_EXPORT___;
